import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { EntityUtils } from '@/common/utils/EntityUtils'
import { useCallback } from 'react'

export const IncCondList = ({ incRuleId }) => {

  const augRowsReq = useCallback(
    EntityUtils.parentFilterAugRowsReq('INC_RULE', incRuleId),
    [incRuleId]
  )
  
  return (
    <EntityList entity="INC_COND" augRowsReq={augRowsReq} />
  )
}